import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
// import { unregister } from './registerServiceWorker';
import 'bootstrap/dist/css/bootstrap.css';
import '../node_modules/bootstrap/dist/css/bootstrap.css';
import { Config } from './Config';

function noop() {}

if (process.env.NODE_ENV !== 'development' && !Config.userTest) {
  console.log = noop;
  console.warn = noop;
//   console.error = noop;
}
// unregister();
ReactDOM.render(<div>{Config.userTest &&<div className="testBanner">TEST SITE V.{Config.version} - API ENDPOINT: {Config.hostUrl.split("technology")[1]} </div>}<App /></div>, document.getElementById('root'));
// ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js